import apiClient from "@/shared/api/apiClient3";

export const getReferenceList = async (params) => {
  try {
    const { data } = await apiClient.get("/directory/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getReferenceList failed", e);
  }
};

export const getReferenceListByCodes = async (params) => {
  try {
    const { data } = await apiClient.post(
      "/directory/batch/",
      {
        ...params,
      },
      {
        metaData: { isNotificationDisabled: true },
      }
    );
    return data;
  } catch (e) {
    console.error("getReferenceListByCodes failed", e);
  }
};

export const createReference = async (params) => {
  const result = await apiClient.post(`directory/`, {
    ...params,
  });
  return result.data;
};

export const getReferenceItem = async (code) => {
  try {
    const { data } = await apiClient.get(`/directory/${code}/`);
    return data;
  } catch (e) {
    console.error("getReferenceItem failed", e);
  }
};

export const updateReference = async (code, params) => {
  const { data } = await apiClient.patch(`/directory/${code}`, {
    ...params,
  });
  return data;
};

export const removeReference = async (code) => {
  const { data } = await apiClient.delete(`/directory/${code}`);
  return data;
};

export const getReferenceItemChildrenList = async (code, params) => {
  try {
    const { data } = await apiClient.get(`/directory/${code}/children`, {
      params,
    });
    return data;
  } catch (e) {
    console.error("getReferenceItemChildrenList failed", e);
  }
};

export const updateReferenceItemChildren = async (code, params) => {
  const { data } = await apiClient.put(`/directory/${code}/children`, {
    ...params,
  });
  return data;
};
